import React, { useState } from 'react';
import Swal from 'sweetalert2';

const Contactus = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Show loading alert
    Swal.fire({
      title: '✦ Sending Message... ✦',
      text: 'Please wait while we send your message.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
      color: '#fff',
      didOpen: () => {
        Swal.showLoading();
      }
    });
    
    try {
      const formPayload = new FormData();
      formPayload.append('name', formData.name);
      formPayload.append('email', formData.email);
      formPayload.append('phone', formData.phone);
      formPayload.append('message', formData.message);
      formPayload.append('_subject', `New Inquiry from ${formData.name} - Agency Bazaar`);
      formPayload.append('_template', 'table');
      formPayload.append('_captcha', 'false');
      formPayload.append('_next', window.location.href);
      
      const response = await fetch('https://formsubmit.co/sandeepsingh241302@gmail.com', {
        method: 'POST',
        body: formPayload,
        headers: {
          'Accept': 'application/json'
        }
      });
      
      Swal.close();
      
      if (response.ok) {
        setFormData({ name: '', email: '', phone: '', message: '' });
        
        // Success alert with close button - NO timer
        Swal.fire({
          title: '✦ Message Sent Successfully! ✦',
          text: 'Thank you for reaching out to us. We\'ll get back to you within 24 hours.',
          icon: 'success',
          confirmButtonText: 'Close',
          confirmButtonColor: '#ff2222',
          background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
          color: '#fff',
          iconColor: '#00d4ff',
          showConfirmButton: true,
          showCloseButton: true,
          closeButtonHtml: '✕',
          focusConfirm: false
        });
      } else {
        Swal.fire({
          title: '✦ Oops! Something Went Wrong ✦',
          text: 'Unable to send message. Please try again later.',
          icon: 'error',
          confirmButtonText: 'Try Again',
          confirmButtonColor: '#ff2222',
          background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
          color: '#fff',
          iconColor: '#ff4444',
          showConfirmButton: true,
          showCloseButton: true,
          closeButtonHtml: '✕'
        });
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      Swal.close();
      Swal.fire({
        title: '✦ Network Error ✦',
        text: 'Please check your internet connection and try again.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#ff2222',
        background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
        color: '#fff',
        iconColor: '#ff4444',
        showConfirmButton: true,
        showCloseButton: true,
        closeButtonHtml: '✕'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <style>
        {`
          .contact-form-wrapper {
            width: 100%;
            min-height: 100vh;
            background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 50px 20px;
            position: relative;
            overflow: hidden;
          }

          .contact-form-wrapper::before {
            content: '';
            position: absolute;
            width: 200%;
            height: 200%;
            background: radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px);
            background-size: 50px 50px;
            animation: float 20s linear infinite;
            pointer-events: none;
          }

          @keyframes float {
            0% {
              transform: translate(0, 0);
            }
            100% {
              transform: translate(-50px, -50px);
            }
          }

          .contact-form-wrapper::after {
            content: '';
            position: absolute;
            top: 20%;
            right: -10%;
            width: 500px;
            height: 500px;
            background: radial-gradient(circle, rgba(255,34,34,0.3), transparent 70%);
            border-radius: 50%;
            filter: blur(60px);
            animation: pulse 4s ease-in-out infinite;
          }

          /* Second decorative blob */
          .contact-form-wrapper .blob-left {
            content: '';
            position: absolute;
            bottom: -10%;
            left: -5%;
            width: 400px;
            height: 400px;
            background: radial-gradient(circle, rgba(0,212,255,0.2), transparent 70%);
            border-radius: 50%;
            filter: blur(60px);
            animation: pulse 5s ease-in-out infinite alternate;
          }

          @keyframes pulse {
            0%, 100% {
              opacity: 0.5;
              transform: scale(1);
            }
            50% {
              opacity: 0.8;
              transform: scale(1.1);
            }
          }

          .form-container {
            max-width: 550px;
            width: 100%;
            animation: glamourFadeIn 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
            position: relative;
            z-index: 1;
            background: rgba(255, 255, 255, 0.05);
            backdrop-filter: blur(20px);
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 30px;
            padding: 50px 40px;
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          }

          @keyframes glamourFadeIn {
            from {
              opacity: 0;
              transform: scale(0.9) translateY(30px);
            }
            to {
              opacity: 1;
              transform: scale(1) translateY(0);
            }
          }

          .form-header {
            text-align: center;
            margin-bottom: 40px;
          }

          .glamour-badge {
            display: inline-block;
            background: linear-gradient(135deg, #ff2222, #ff6b6b);
            padding: 8px 20px;
            border-radius: 50px;
            font-size: 12px;
            font-weight: 600;
            color: white;
            margin-bottom: 20px;
            letter-spacing: 2px;
            box-shadow: 0 5px 20px rgba(255,34,34,0.3);
          }

          .form-header h3 {
            font-size: 42px;
            font-weight: 800;
            background: linear-gradient(135deg, #ffffff, #ffd6d6);
            background-clip: text;
            -webkit-background-clip: text;
            color: transparent;
            margin-bottom: 12px;
            letter-spacing: -0.5px;
            line-height: 1.1;
          }

          .form-header p {
            color: rgba(255, 255, 255, 0.7);
            font-size: 16px;
            margin-top: 10px;
          }

          .contact-info-mini {
            display: flex;
            justify-content: center;
            gap: 30px;
            margin-top: 20px;
            flex-wrap: wrap;
          }

          .contact-info-mini .info-item {
            display: flex;
            align-items: center;
            gap: 8px;
            color: rgba(255, 255, 255, 0.8);
            font-size: 14px;
          }

          .contact-info-mini .info-icon {
            width: 35px;
            height: 35px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
          }

          .form-group {
            margin-bottom: 25px;
            position: relative;
          }

          .form-group .input-icon {
            position: absolute;
            left: 20px;
            top: 50%;
            transform: translateY(-50%);
            color: rgba(255, 255, 255, 0.5);
            font-size: 16px;
            pointer-events: none;
          }

          .form-group input,
          .form-group textarea {
            width: 100%;
            padding: 16px 20px 16px 20px;
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 16px;
            font-size: 14px;
            transition: all 0.4s ease;
            background: rgba(255, 255, 255, 0.08);
            color: white;
            font-family: inherit;
            backdrop-filter: blur(10px);
          }

          .form-group textarea {
            resize: vertical;
            min-height: 130px;
          }

          .form-group input::placeholder,
          .form-group textarea::placeholder {
            color: rgba(255, 255, 255, 0.5);
          }

          .form-group input:focus,
          .form-group textarea:focus {
            outline: none;
            border-color: #ff2222;
            background: rgba(255, 255, 255, 0.12);
            box-shadow: 0 0 0 4px rgba(255, 34, 34, 0.2);
            transform: translateY(-2px);
          }

          .form-group input:focus,
          .form-group textarea:focus {
            animation: glowPulse 1.5s infinite;
          }

          @keyframes glowPulse {
            0%, 100% {
              box-shadow: 0 0 0 4px rgba(255, 34, 34, 0.2);
            }
            50% {
              box-shadow: 0 0 0 8px rgba(255, 34, 34, 0.4);
            }
          }

          .submit-btn {
            width: 100%;
            padding: 18px;
            background: linear-gradient(135deg, #ff2222, #cc0000, #ff2222);
            background-size: 200% 200%;
            color: white;
            border: none;
            border-radius: 16px;
            font-size: 16px;
            font-weight: 700;
            cursor: pointer;
            transition: all 0.4s ease;
            position: relative;
            overflow: hidden;
            text-transform: uppercase;
            letter-spacing: 1px;
            animation: gradientShift 3s ease infinite;
            margin-top: 10px;
          }

          @keyframes gradientShift {
            0%, 100% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
          }

          .submit-btn::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
            transition: left 0.5s ease;
          }

          .submit-btn:hover::before {
            left: 100%;
          }

          .submit-btn:hover {
            transform: translateY(-3px);
            box-shadow: 0 15px 30px rgba(255, 34, 34, 0.4);
            letter-spacing: 2px;
          }

          .submit-btn:active {
            transform: translateY(0);
          }

          .submit-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
            transform: none;
          }

          .form-decoration {
            position: absolute;
            bottom: -30px;
            right: -30px;
            width: 150px;
            height: 150px;
            background: radial-gradient(circle, rgba(255,34,34,0.2), transparent);
            border-radius: 50%;
            filter: blur(30px);
            pointer-events: none;
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .contact-form-wrapper {
              padding: 30px 15px;
              min-height: auto;
            }

            .form-container {
              padding: 35px 25px;
              border-radius: 20px;
            }

            .form-header h3 {
              font-size: 32px;
            }

            .glamour-badge {
              font-size: 10px;
              padding: 6px 15px;
            }

            .form-header p {
              font-size: 14px;
            }

            .contact-info-mini {
              gap: 20px;
            }

            .contact-info-mini .info-item {
              font-size: 12px;
            }

            .contact-info-mini .info-icon {
              width: 30px;
              height: 30px;
              font-size: 14px;
            }
          }

          @media (max-width: 480px) {
            .form-container {
              padding: 25px 20px;
              border-radius: 15px;
            }

            .form-header h3 {
              font-size: 28px;
            }

            .form-header p {
              font-size: 13px;
            }

            .form-group input,
            .form-group textarea {
              padding: 14px 16px;
              font-size: 13px;
            }

            .form-group textarea {
              min-height: 110px;
            }

            .submit-btn {
              padding: 14px;
              font-size: 14px;
            }

            .contact-info-mini {
              gap: 15px;
            }
          }
        `}
      </style>

      <div className="contact-form-wrapper">
        <div className="blob-left"></div>
        
        <div className="form-container">
          <div className="form-header">
            <div className="glamour-badge">✦ GET IN TOUCH ✦</div>
            <h3>Contact Us</h3>
            <p>Have questions? We'd love to hear from you.</p>
            
            <div className="contact-info-mini">
              <div className="info-item">
                <div className="info-icon">📧</div>
                <span>
info@theagencybazaar.com</span>
              </div>
              <div className="info-item">
                <div className="info-icon">📞</div>
                <span>+91 7715879666</span>
              </div>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Full Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <textarea
                name="message"
                placeholder="How can we help you?"
                value={formData.message}
                onChange={handleChange}
                required
              />
            </div>

            <button 
              type="submit" 
              className="submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? '✦ SENDING... ✦' : '✦ SEND MESSAGE ✦'}
            </button>
          </form>
          <div className="form-decoration"></div>
        </div>
      </div>
    </>
  );
};

export default Contactus;


